import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../Display/Icon/Icon';

function ResourcesHeader({
  onSelectedProgramsClick,
  selectedProgramsAmount = 0,
  showAddedResourcesBtn = false,
}) {
  return (
    <div className="resources-header">
      <div className="flex gap-4 items-center mb-4 justify-between">
        <div className="flex items-center">
          <h1 className="flex items-center" data-testid="resourcesHeaderText">
            <Icon
              id="resources-header-magnifying-glass-icon"
              className="w-8 h-8 ml-3 mr-2"
              icon="LogoShield"
              color="#182A44"
            />
            Browse Resources
          </h1>
        </div>
        {showAddedResourcesBtn && (
          <button
            type="button"
            className="bg-dark-blue text-white rounded-md p-3 relative flex gap-x-2 items-center"
            data-testid="addedResources"
            name="addedResources"
            onClick={onSelectedProgramsClick()}
          >
            <span className={classNames(
              'number-circle inline-flex items-center justify-center leading-8 h-6 w-6 rounded-full text-center border-2 border-solid whitespace-no-wrap',
              selectedProgramsAmount > 0 ? 'border-grass-green' : 'border-white',
            )}
            >
              <span className="count-text inline-block text-base text-white w-full">{selectedProgramsAmount}</span>
            </span>
            <span className="text-white">Added Resources</span>
          </button>
        )}
      </div>
    </div>
  );
}

ResourcesHeader.propTypes = {
  selectedProgramsAmount: PropTypes.number,
  onSelectedProgramsClick: PropTypes.func.isRequired,
  showAddedResourcesBtn: PropTypes.bool,
};

export default ResourcesHeader;
